import { Flex, Typography } from "antd";
import styles from "./index.module.less";
import { JobDto } from "../../constant";
import TimeIcon from '../../imgs/time.svg?react'
import LocationIcon from '../../imgs/location.svg?react'
import CategoryIcon from '../../imgs/category.svg?react'
const {Paragraph} = Typography
const JobCard = ({
  data,
  onClick,
}: {
  data: JobDto;
  onClick: () => void;
}) => {
  const { title, desc, date, locations, category } = data;
  return (
    <div className={styles.jobCard} onClick={onClick}>
      <div className={styles.header}>
        <div className={styles.jobTitle}>{title}</div>
        <Flex gap={'.2rem'} className={styles.jobInfo}>
          <Flex align="center" gap={4}><CategoryIcon />{category}</Flex>
          <Flex align="center" gap={4}><LocationIcon />{locations.join(',')}</Flex>
          <Flex align="center" gap={4}><TimeIcon />{date}</Flex>
        </Flex>
      </div>
      <Paragraph ellipsis={{
        rows: 2,
      }} className={styles.jobDesc}>{desc}</Paragraph>
    </div>
  );
};
export default JobCard;
